import { useTranslation } from 'react-i18next';
import React from 'react';
import { COLOR } from '@src/styles/color';
import CommonButton from '@src/new-components/Button';

const ButtonActionDrawer = ({ handleApplyFilter, handleResetFilterDraft }) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '0 16px',
        bottom: '0',
        position: 'sticky',
        width: '91%',
        background: COLOR.white,
        height: '70px',
      }}
    >
      <CommonButton
        variant="outlineSmall"
        textProps={{
          variantText: 'body-14-semibold',
          color: COLOR.darkBlue,
        }}
        customStyle={{
          height: '40px',
          borderRadius: '8px',
          padding: '8px 24px',
          width: '30%',
        }}
        onClick={handleResetFilterDraft}
      >
        {t('reset')}
      </CommonButton>
      <CommonButton
        variant="contained"
        onClick={handleApplyFilter}
        textProps={{
          variantText: 'body-14-semibold',
          color: COLOR.darkBlue,
        }}
        customStyle={{
          height: '40px',
          borderRadius: '8px',
          padding: '8px 24px',
          flex: 1,
        }}
      >
        {t('apply')}
      </CommonButton>
    </div>
  );
};

export default ButtonActionDrawer;
